module.exports = __webpack_public_path__ + "img/07.ce21dc17.png";